export { default } from './useModal';
